import { ClipboardList, CheckCheck, RefreshCw } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Passo = { titulo: string; texto: string; icone: LucideIcon };

// Copy adaptada de apps/site/landing-antiga.html (seção "Como funciona") e do
// princípio do produto dado no briefing: "o contador cadastra a sociedade
// uma vez; a alteração é um evento; a consolidação é uma renderização".
export const PASSOS: readonly Passo[] = [
  {
    icone: ClipboardList,
    titulo: 'Cadastra a sociedade',
    texto:
      'Sócios, capital, quotas, CNAEs, sede, administração — uma vez. 23 regras travam na hora o que não fecha: CPF inválido, soma de quotas diferente do capital, data impossível.',
  },
  {
    icone: CheckCheck,
    titulo: 'O sistema confere e monta',
    texto:
      'Mais 7 regras conferem o documento contra o Código Civil e a Junta Comercial antes de virar cláusula. O contrato sai em .docx editável e PDF, com gênero concordando e valor por extenso batendo com o algarismo.',
  },
  {
    icone: RefreshCw,
    titulo: 'A alteração é um evento',
    texto:
      'Mudou a sede? Você registra a mudança, não reescreve o contrato. A consolidação não é redigitada por ninguém — é uma renderização do estado atual, e por construção não diverge do preâmbulo.',
  },
] as const;
